/* eslint-disable no-console */

<template>
    <BaseDialog
        v-if="dialog"
        :max_width="`80%`"
        :dialog="dialog"
        title="Ente"
        v-on:close_dialog="closeDialog">
            <!--v-form v-model="valid" ref="form">
                <v-text-field dense outlined
                    class="d-flex flex-column"
                    label="nome*"
                    id="id"
                    v-model="org.name"
                    :rules= "[rules.mandatory, rules.nameRules]"
                ></v-text-field>
                <v-text-field dense outlined
                    class="d-flex flex-column"
                    label="partita iva*"
                    id="id"
                    v-model="org.piva"
                    :rules= "[rules.mandatory, rules.piva]"
                ></v-text-field>
                <v-text-field dense outlined
                    class="d-flex flex-column"
                    label="Codice fiscale"
                    id="id"
                    v-model="org.fiscalcode"
                ></v-text-field>
            </v-form-->
            <v-form v-model="valid" ref="form">
            <v-container>
                <v-row no-gutters>
                    <v-col cols="12" md="6">
                        <v-text-field dense outlined
                            v-model="org.name"
                            label="ragione sociale*"
                            :rules="[rules.nameRules, rules.mandatory]"
                        ></v-text-field>
                    </v-col>
                    
                </v-row>
                <v-row no-gutters>
                    <v-col cols="12" class="text-subtitle-1">
                        Dati fatturazione
                    </v-col>
                </v-row>
                <v-row no-gutters>
                    <v-col cols="6" >
                        <v-text-field dense outlined
                            label="partiva iva*"
                            v-model="org.piva"
                            :rules="[rules.piva, rules.mandatory]"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="6" class="pl-2">
                        <v-text-field dense outlined
                            label="codice fiscale"
                            v-model="org.fiscal_code"
                            :rules="[rules.fiscal_code]"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row no-gutters>
                    <v-col cols="6">
                        <v-text-field dense outlined
                            label="PEC"
                            v-model="org.pec"
                            :rules="[rules.emailRules]"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="6" class="pl-2">
                        <v-text-field dense outlined
                            label="codice univoco"
                            v-model="org.unique_code"
                            :rules="[rules.nameRules]"
                        ></v-text-field>
                    </v-col>
                </v-row> 
                <v-row no-gutters>
                    <v-col cols="12" class="text-subtitle-1">
                        Contatto
                    </v-col>
                </v-row>
                <v-row no-gutters>
                    <v-col cols="4">
                        <v-text-field dense outlined
                            label="nome"
                            v-model="org.contact_name"/>
                    </v-col>
                    <v-col cols="4" class="pl-2">
                        <v-text-field dense outlined
                            label="email"
                            v-model="org.contact_email" 
                            :rules="[rules.emailRules]"/>
                    </v-col>
                    <v-col cols="4" class="pl-2">   
                        <v-text-field dense outlined
                            label="telefono"
                            v-model="org.contact_phone" />
                    </v-col>
                </v-row>
                <v-row no-gutters>
                    <v-col cols="12" class="text-subtitle-1">
                        Sede legale
                    </v-col>
                </v-row>
                <v-row no-gutters>
                    <v-col cols="10">
                    <v-text-field dense outlined
                        label="indirizzo"
                        v-model="org.address"
                    ></v-text-field></v-col>
                    <v-col cols="2" class="pl-2">   
                    <v-text-field dense outlined
                        label="n° civico"
                        v-model="org.addrNum"
                    ></v-text-field>   
                    </v-col>
                </v-row>
                <v-row no-gutters>
                    <v-col cols="12" md="6">
                        <v-combobox dense outlined
                            :items="districts.cities"
                            item-value="id"
                            item-text="name"
                            label="città"
                            v-model="city"
                            return-object
                            @change="changeCity"
                        ></v-combobox>
                    </v-col>
                    <v-col cols="4" md="2" class="pl-md-2">
                        <v-combobox dense outlined
                            :items="zips"
                            label="CAP"
                            v-model="org.zip"
                            required
                        ></v-combobox>
                    </v-col>
                    <v-col cols="8" md="4" class="pl-2">
                        <v-combobox dense outlined
                            label="provincia*"
                            :items="districts.districts"
                            v-model="district"
                            item-value="id"
                            item-text="name"
                            return-object
                            @change="changeDistrict"
                            required
                        ></v-combobox>
                    </v-col>
                </v-row>
                <v-row no-gutters>
                    <v-col cols="8">
                        <v-progress-linear
                            v-if="uploading"
                            color="primary"
                            indeterminate
                            rounded
                            height="6"
                        ></v-progress-linear>
                        <v-img v-if="org.file_ref" :src="'/mastercalFiles'+org.file_ref"></v-img>
                    </v-col>
                    <v-col cols="4" class="pl-4">
                        <VueUploadComponent
                            ref="upload"
                            v-model="files"
                            input-id="file1"
                            class="btn"
                            accept="image/*"
                            @input-file="inputFile"
                            @input-filter="inputFilter"
                            >
                            <v-btn :disabled="$store.state.offline" elevation-2 color="primary">
                                <span v-if="org.file_ref" class="pr-2">aggiorna</span><span v-else class="pr-2">carica</span>logo
                            </v-btn>
                        </VueUploadComponent>
                    </v-col>
                    <v-col cols="12">
                        <v-alert type="error" :value="failed">
                            errore durante il caricamento del file
                        </v-alert>
                    </v-col>
                </v-row>
            </v-container>
            </v-form>
            <div class="pa-4">
                <v-alert
                    v-if="save_error"
                    dense
                    type="warning"
                    >
                    <div class="d-flex flex-column">
                        <div class="font-weight-bold">Salvataggio fallito</div>
                        <div>Riprovare oppure segnalare il problema all'amministratore di sistema.</div>
                    </div>
                </v-alert>
            </div>
            <template v-slot:action>
                <div v-can="{obj_type:'organism', action: 'edit'}" class="d-flex align-center justify-center my-4">
                    <v-btn color="primary" :disabled="$store.state.offline || !valid || !hasLogo" @click="saveAndClose">Conferma</v-btn>
                    <v-btn text @click="closeDialog">Annulla</v-btn>
                </div>            
            </template>
    </BaseDialog>
</template>

<script>
import {getModel} from "../../utils/model"
import {f_rules} from "../../utils/commonUtils"
import BaseDialog from '../../components/dialogs/BaseDialog'
import VueUploadComponent from "vue-upload-component";

export default {
components: {BaseDialog, VueUploadComponent},
data() {
    return {
        rule:f_rules,
        dialog: false,
        org: null,  
        valid: false,
        justCreated: true,
        rules: f_rules,
        zips: [],
        district: null,
        city: null,
        districts: {},
        uploading: false,
        files: [],
        failed: false,
        save_error: false
    }
},
async mounted(){
    this.districts = await this.$store.state.$pouch.get('system', "district:ITALIA")
},
computed:{
    hasLogo(){
        if(this.org.file_ref){
            return true
        } else {
            return false
        }
    }
},
methods: {
    async reset(org_id){
        console.log("DEBUG user reset", org_id)
        this.files = []
        this.district = null
        this.city = null
        if(org_id != undefined && org_id != null){
            this.org =  await this.$store.state.$pouch.get('registry', org_id)
            this.justCreated = false;
            if (this.org.city) {
                let res = this.districts.cities.filter(d => {return this.org.city == d.name})
                if (res && res.length>0) {
                    this.city = res[0]
                } else {
                    this.city = {'name': this.org.city, zip:[], district:''}
                    this.districts.cities.push(this.city)
                }
            }
            if (this.org.district) {
                let res = this.districts.districts.filter(d => {return this.org.district== d.id})
                if (res && res.length>0) {
                    this.district = res[0]
                } else {
                    this.district = {'name': this.org.district, id: this.org.district}
                    this.districts.districts.push(this.district)
                }
            }
        } else {
            this.justCreated = true
            let Org = getModel('Organism')
            this.org = Org({
                created_by: this.$store.state.user._id,
                updated: (new Date()).getTime()
            })
        }
        
        this.dialog = true
    },
    closeDialog(){
        this.dialog = false
    },
    updateValidity(valid) {
        this.valid = valid
    },
    inputFilter: function (newFile, oldFile, prevent) {
        if (newFile && !oldFile) {
            // Filter non-pdf file
            if (!/\.(jpeg|jpe|jpg|gif|png|webp)$/i.test(newFile.name)) {
            console.log("filtered non image file")
            return prevent()
            }
        }
    },
    async inputFile(){
        // this.$refs.upload.active = true
        this.uploading = true;
        this.failed = false
        let uploadedFile = this.files[0].file
        console.log("file selected", uploadedFile.name)
        let filename = uploadedFile.name
        let extensionIndex =  uploadedFile.name.lastIndexOf('.')
        let extension = uploadedFile.name.slice(extensionIndex)
        let uuidv1 = require('uuid/v1')
        let name = uuidv1()+extension
        console.log("file selected NAME", name)
        let form = new window.FormData()
        form.append('file', uploadedFile)
        let res = await this.axios.post(
            "/mastercal/orgs/files", form, 
            {
                headers: {"Content-Type": "multipart/formdata"},
                params: {file_name: name}
            }).catch((error) => {
                if(error){
                    console.log("error status", error);
                    this.failed = true
                    this.uploading = false
                }
            })
        console.log("result axios", res)
        if(res.status == 200){
            console.log("confirmed update", res.data)
            this.org.file_ref = res.data
            this.org.file_name = filename
        }
        this.uploading = false
    },
    // save(){
    //     console.log("DEBUG, saving user", this.user)
    //     this.$store.state.$pouch.put('users', this.user).then(
    //         res => {
    //             if(res.ok){
    //                 console.log("OPERATION SUCCESSFUL")
    //                 this.closeDialog();
    //             } else {
    //                 console.log("DEBUG, something failed on saving item ", res);
    //             }
    //         }
    //     )
    // },
    async saveAndClose(){
        //let data = this.$refs.registry_form.getData()
        this.save_error = false;
        try {
            this.org.updated_by = this.$store.state.user._id
            this.org.updated = (new Date()).getTime()
            console.log("ORG", this.org)
            await this.$store.state.$pouch.put('registry', this.org)
            this.$emit('saveOrg')
            this.closeDialog();
        } catch (error) {
            this.save_error = true;
            console.log('error', error)
        }
    },
    changeCity(item) {
        if ( typeof(item) === "string") {
            this.org.city= item
        } else {
            this.org.city = item.name
        }
        this.org.zip = ""
        this.zips = []
        if (item.zip) {
            this.zips = item.zip
            this.org.zip = this.zips[0]
        } else {
            this.zips = []
        }
        if (item.district) {
            let res = this.districts.districts.filter(d => {return item.district == d.id})
            if (res && res.length>0) {
                this.district = res[0]
                this.org.district = res[0].id
            }
        } else {
            this.district = null
        }
    },
    changeDistrict(item) {
        if (typeof(item) === "string") {
            this.org.district = item
        } else {
            this.org.district = item.id
        }
    }

},
}
</script>

<style>

</style>
